import React from 'react';
import ParentPlaceholderBigIcon from '@/assets/images/parent-placeholder.png';

const ParentPlaceholder: React.FC = () => {
	return (
		<div className="parent-placeholder-content">
			<div className="placeholder-icon">
				<img
					src={ParentPlaceholderBigIcon}
					alt="Parent Placeholder"
				/>
			</div>

			<div className="placeholder-text">
				<h3>Öğrencinin eşleşmiş bir velisi veya öğretmeni bulunmamaktadır.</h3>
				<p>
					Öğrenci, Doping Hafıza <b>Profil</b> sayfasından velisini eklemesi için yönlendirilmelidir
				</p>
			</div>
		</div>
	);
};

export default ParentPlaceholder;
